import axios from '../utils/axios';

export default function updateSeekerEmailStatus (adminId, data) {
    return axios.post(`/admin/${adminId}/jobseeker-admin/v2/admin-recruiter/changeemailstatus`, data);
}